var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.platform.isPC)?_c('slides-pc'):_c('slides-m')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }